import I18n from 'I18n';
import { Flex } from 'foundations-components/components/Flex';
import { useMediaBySize, usePrefersReducedMotion } from '../hooks/useMedia';
import { useCallback, useEffect, useMemo, useState } from 'react';
import AIAgentCard from './AIAgentCard';
import ClickableCarousel from './ClickableCarousel';
import ScrollableCarousel from './ScrollableCarousel';
import { jsx as _jsx } from "react/jsx-runtime";
const AGENT_TITLE_KEYS = {
  customer: 'hsocCreditsExplainer.aiAgents.customer.title',
  prospecting: 'hsocCreditsExplainer.aiAgents.prospecting.title',
  data: 'hsocCreditsExplainer.aiAgents.data.title'
};
const AIAgentsCarousel = ({
  agents,
  onLinkClick,
  onCarouselClick,
  onCarouselScroll
}) => {
  const [stepIndex, setStepIndex] = useState(0);
  const isSmOrBigger = useMediaBySize('sm');
  const prefersReducedMotion = usePrefersReducedMotion();
  const steps = useMemo(() => agents.map(agent => ({
    id: agent,
    content: /*#__PURE__*/_jsx(AIAgentCard, {
      agent: agent,
      onLinkClick: onLinkClick
    }),
    alt: I18n.text(AGENT_TITLE_KEYS[agent]),
    agent: I18n.text(AGENT_TITLE_KEYS[agent], {
      locale: 'en-us'
    })
  })), [agents, onLinkClick]);

  // Guard against stepIndex going out of bounds when steps shrinks (e.g. prospecting agent
  // removed) or when the carousel switches between mobile and desktop layouts.
  useEffect(() => {
    setStepIndex(prev => prev >= steps.length ? 0 : prev);
  }, [steps]);
  const handleClick = useCallback((index, direction) => {
    onCarouselClick === null || onCarouselClick === void 0 || onCarouselClick(index, direction);
    setStepIndex(index);
  }, [onCarouselClick]);
  const handleScroll = useCallback((index, direction) => {
    onCarouselScroll === null || onCarouselScroll === void 0 || onCarouselScroll(index, direction);
  }, [onCarouselScroll]);
  return /*#__PURE__*/_jsx(Flex, {
    inlineSize: "100%",
    backgroundColor: "fill-accent-light-orange-subtle-alt",
    alignItems: "center",
    justifyContent: "center",
    children: isSmOrBigger || prefersReducedMotion ? /*#__PURE__*/_jsx(ClickableCarousel, {
      steps: steps,
      stepIndex: stepIndex,
      onClick: handleClick
    }) : /*#__PURE__*/_jsx(ScrollableCarousel, {
      steps: steps,
      onScroll: handleScroll
    })
  });
};
export default AIAgentsCarousel;